const getters = {
    purchasesTableColumns: (state) => state.purchasesTableColumns,
    getColumnProperty: (state) => (columnName, columnProperty) => {
        return state.purchasesTableColumns?.[columnName]?.[columnProperty] ?? false
    },
    lineHeightsType: (state) => state.lineHeightsType,
    pagination: (state) => state.pagination,
    tableSettingId: (state) => state.tableSettingId,
    isActiveSearch: (state) => state.isActiveSearch,
    isKeywordShown: (state) => state.isKeywordShown,
    keywordsColor: (state) => state.keywordsColor,
}

export default getters
